import React from "react";
import { Typography, Box, useMediaQuery, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import LoansComponent from "../../LoansComponent";
import { setCurrentMooloanView } from "../../../redux/uiSlice";
import CowIcon from "../../CowIcon";

// Get width from environment variable with fallback
const MOBILE_APP_WIDTH = parseInt(
  process.env.REACT_APP_MOBILE_APP_WIDTH || "500"
);

const HomeView: React.FC = () => {
  const isMobileView = useMediaQuery(`(max-width:${MOBILE_APP_WIDTH}px)`);
  const { isCompletingLogin } = useAppSelector((state) => state.ui);
  const { currentMooloanView } = useAppSelector((state) => state.ui);
  const dispatch = useAppDispatch();
  return (
    <Box
      sx={{
        p: 2,
        width: "100%",
        maxWidth: MOBILE_APP_WIDTH,
        margin: "auto",
        // Mobile-specific styles
        ...(isMobileView && {
          maxWidth: "100%",
          px: 1, // Smaller horizontal padding on mobile
        }),
        // Desktop-specific styles
        ...(!isMobileView && {
          boxShadow: 1,
          borderRadius: 2,
        }),
      }}
    >
      {!isCompletingLogin && (
        <>
          <Box sx={{ mb: 2, justifyContent: "space-between", display: "flex" }}>
            <Typography
              variant="h4"
              sx={{
                fontSize: { xs: "1.5rem", sm: "2rem" }, // Responsive font size
                mb: 2,
                textAlign: "left", // Align text to the left
              }}
            >
              Moo Loans
            </Typography>
            <Button
              variant="text"
              onClick={() => {
                if (currentMooloanView === "investment") {
                  dispatch(setCurrentMooloanView("personal"));
                } else {
                  dispatch(setCurrentMooloanView("investment"));
                }
              }}
              color="primary"
            >
              <CowIcon
                fill={currentMooloanView === "investment" ? "green" : "white"}
              />
            </Button>
          </Box>
          <LoansComponent />
        </>
      )}
    </Box>
  );
};

export default HomeView;
